import { createContext, useState, useContext } from 'react'
import Languages from '../languages'

export const LanguageContext = createContext()

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(localStorage.getItem('languageName') || 'EN') // Default language

  const changeLanguage = async (lang) => {
    if (Languages[lang]) {
      setLanguage(lang)
    }
  }

  return (
    <LanguageContext.Provider
      value={{
        languageName: language,
        language: Languages[language],
        changeLanguage,
        isRTL: language === 'AR',
      }}
    >
      {children}
    </LanguageContext.Provider>
  )
}

export const useLanguage = () => useContext(LanguageContext)
